import { SupportedPlatforms } from '@smg-real-estate/domus';
import { type VueHeadClient } from '@unhead/vue';
import { type Pinia } from 'pinia';
import { type App, type Component } from 'vue';
import { type I18n } from 'vue-i18n';
import { type Router } from 'vue-router';

import { createI18nByPlatform } from '@/i18n/setup/i18nSetupHg';

import { createVueApp } from './createApp';

export async function createAppByPlatform(appComponent: Component): Promise<{
  app: App<Element>;
  router: Router;
  pinia: Pinia;
  head: VueHeadClient;
  i18n: I18n;
}> {
  const i18n = await createI18nByPlatform();

  return createVueApp(appComponent, i18n, SupportedPlatforms.hg);
}
